import { render, staticRenderFns } from "./BoNavGroup.vue?vue&type=template&id=74ad8d04"
import script from "./BoNavGroup.vue?vue&type=script&lang=js"
export * from "./BoNavGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports